/**
 * Formats a shipping address object into a multi-line string
 * Shared utility for displaying shipping addresses consistently across the app
 */
export function formatShippingAddressString(
  address:
    | {
        name?: string | null;
        address1?: string | null;
        address2?: string | null;
        city?: string | null;
        province?: string | null;
        province_code?: string | null;
        zip?: string | null;
        country?: string | null;
        country_code?: string | null;
      }
    | null
    | undefined,
): string | null {
  if (!address) {
    return null;
  }

  const parts = [
    address.name,
    address.address1,
    address.address2,
    [address.city, address.province || address.province_code, address.zip]
      .filter(Boolean)
      .join(", "),
    address.country || address.country_code,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join("\n") : null;
}
